import { render, staticRenderFns } from "./EntriesSessions.vue?vue&type=template&id=b460dc0c"
import script from "./EntriesSessions.vue?vue&type=script&lang=js"
export * from "./EntriesSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports